import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import access_ControlStore from "../../Stores/Access_ControlStores";
import Access_ControlActions from "../../Actions/Access_ControlActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

export default function ConfirmationModalWithPassword({
  openConfirmationModal,
  confirmationTitle,
  confirmationMessage,
  onSubmitCallback,
  onCancelCallback,
  callBackFunctionData,
}) {
  const [open, setOpen] = React.useState(openConfirmationModal);
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const handleClose = () => {
    setOpen(false);
    onCancelCallback();
  };

  useEffect(() => {
    function passwordValidationSuccess() {
      var result = access_ControlStore.getPasswordValidationResult();
      setGlobalSpinner(false);
      if (result) {
        handleClose();
        onSubmitCallback(callBackFunctionData);
      }
    }

    function passwordValidationFailure() {
      var result = access_ControlStore.getPasswordValidationResult();
      setGlobalSpinner(false);
      toast.error(localization.incorrectPassword);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.PASSWORD_VALIDATION_SUCCESS,
      passwordValidationSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.PASSWORD_VALIDATION_FAILURE,
      passwordValidationFailure
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.PASSWORD_VALIDATION_SUCCESS,
        passwordValidationSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.PASSWORD_VALIDATION_FAILURE,
        passwordValidationFailure
      );
    };
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const password = formJson.password;
    setGlobalSpinner(true);
    Access_ControlActions.login(
      {
        username: sessionStorage.getItem("username"),
        password: password,
        language: language,
        OrganisationId: sessionStorage.getItem("organizationID"),
        IsPublicWebsite: false,
      },
      true
    );
    //onSubmitCallback(password);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        slotProps={{
          backdrop: {
            onClick: (event) => event.stopPropagation(), // Prevent backdrop click from closing
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>{confirmationTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText component={"div"} sx={{ fontSize: "1.2rem" }}>
              {confirmationMessage}
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="password"
              name="password"
              label={localization.password}
              type="password"
              fullWidth
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{localization.cancel}</Button>
            <Button type="submit">{localization.ok}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}
